(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.QBQController = (function(superClass) {
    extend(QBQController, superClass);

    function QBQController(scope, transitions, service, interval1) {
      var interval, ref, ref1;
      this.scope = scope;
      this.transitions = transitions;
      this.service = service;
      this.interval = interval1;
      this.fetchData = bind(this.fetchData, this);
      if ((ref = App.sidebar) != null) {
        ref.close();
      }
      if ((ref1 = App.angularSidebar) != null) {
        ref1.close();
      }
      this.scope.title = 'QBQ';
      this.scope.fullpage = true;
      this.scope.absolute_errors = true;
      this.scope.showTooManyItemsMessage = false;
      this.scope.choice = '';
      this.scope.queueItems = [];
      this.scope.extra = {
        orders: ''
      };
      this.scope.progressBars = {
        success: 0,
        danger: 0
      };
      this.scope.triggerButtonDisabled = true;
      this.scope.trigger = (function(_this) {
        return function(choice, extra) {
          _this.scope.triggerButtonDisabled = true;
          return _this.service.triggerSync(choice, extra);
        };
      })(this);
      this.fetchData();
      interval = this.interval(this.fetchData, 2000);
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          return _this.interval.cancel(interval);
        };
      })(this));
    }

    QBQController.prototype.fetchData = function() {
      return this.service.getQueueData().then((function(_this) {
        return function(result) {
          var i, len, numError, numQueued, numSuccess, queueItem, ref;
          _this.scope.queueItems = result.data;
          numSuccess = 0;
          numError = 0;
          numQueued = 0;
          ref = result.data;
          for (i = 0, len = ref.length; i < len; i++) {
            queueItem = ref[i];
            if (queueItem.s === 's') {
              numSuccess += 1;
            } else if (queueItem.s === 'e') {
              numError += 1;
            } else if (queueItem.s === 'q') {
              numQueued += 1;
            }
          }
          _this.scope.progressBars['success'] = parseInt(100 * parseFloat(numSuccess) / result.data.length + 0.5);
          _this.scope.progressBars['danger'] = parseInt(100 * parseFloat(numError) / result.data.length + 0.5);
          if (numQueued === 0) {
            return _this.scope.triggerButtonDisabled = false;
          } else {
            return _this.scope.triggerButtonDisabled = true;
          }
        };
      })(this));
    };

    return QBQController;

  })(Controller);

}).call(this);
